<!--
 * @Description: 富文本编辑器组件
 * @Author: your name
 * @Date: 2023-08-20
 * @LastEditTime: 2025-04-20 16:42:38
-->
<template>
  <div class="mc-rich-text">
    <div v-if="!reloading">
      <FaRichText 
        ref="richTextEditor"
        v-model="innerContent" 
        :height="height"
        :placeholder="placeholder"
        @change="handleChange"
        @input="handleInput"
        @blur="handleBlur"
        @ready="handleEditorReady"
      />
    </div>
    <div v-else class="editor-loading">
      加载编辑器中...
    </div>
  </div>
</template>

<script>
// 创建一个简单的事件总线
const eventBus = new Vue();

export default {
  name: 'McRichText',
  
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入内容...'
    },
    height: {
      type: [Number, String],
      default: 350
    },
    debug: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    return {
      innerContent: '',
      editorInitialized: false,
      reloading: false,
      editor: null,
      uniqueId: 'editor_' + Date.now() + '_' + Math.floor(Math.random() * 1000)
    };
  },
  
  watch: {
    value: {
      handler(newVal) {
        this.innerContent = newVal || '';
        this.updateEditor();
      },
      immediate: true
    }
  },
  
  created() {
    // 监听全局刷新事件
    eventBus.$on('refresh-all-editors', this.forceRefreshEditor);
    
    // 监听针对特定组件的刷新事件
    eventBus.$on('dialog-opened', () => {
      // 稍微延迟刷新，确保DOM已经渲染
      setTimeout(() => {
        this.forceRefreshEditor();
      }, 300);
    });
  },
  
  mounted() {
    // 初始挂载时刷新编辑器
    this.$nextTick(() => {
      this.forceRefreshEditor();
    });
  },

  activated() {
    // 在keep-alive组件激活时重新初始化编辑器
    this.forceRefreshEditor();
  },
  
  beforeDestroy() {
    // 移除事件监听
    eventBus.$off('refresh-all-editors', this.forceRefreshEditor);
    eventBus.$off('dialog-opened');
  },
  
  methods: {
    handleEditorReady(editor) {
      this.editor = editor;
      this.editorInitialized = true;
      
      // 设置初始内容
      if (this.innerContent) {
        editor.setContent(this.innerContent);
      }
      
      // 设置焦点到编辑器
      this.$nextTick(() => {
        try {
          editor.focus();
        } catch (e) {
          console.error('设置编辑器焦点失败:', e);
        }
      });
    },

    forceRefreshEditor() {
      this.reloading = true;
      this.editorInitialized = false;
      
      // 延迟重新加载编辑器
      setTimeout(() => {
        this.reloading = false;
        
        // 允许DOM更新后再进行初始化
        this.$nextTick(() => {
          // 初始化在handleEditorReady中会完成
          if (this.editor) {
            try {
              this.editor.focus();
            } catch (e) {
              // 忽略可能的焦点错误
            }
          }
        });
      }, 200);
    },

    updateEditor() {
      if (this.editor && this.editorInitialized) {
        try {
          this.editor.setContent(this.innerContent || '');
        } catch (e) {
          this.forceRefreshEditor();
        }
      }
    },
    
    handleChange(val) {
      this.innerContent = val;
      this.$emit('input', val);
      this.$emit('change', val);
    },
    
    handleInput(val) {
      this.innerContent = val;
      this.$emit('input', val);
    },
    
    handleBlur() {
      // 确保在失焦时也触发值更新
      this.$emit('input', this.innerContent);
    }
  }
};

// 导出事件总线供外部使用
export const richTextEventBus = eventBus;
</script>

<style lang="scss" scoped>
.mc-rich-text {
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  
  .editor-loading {
    width: 100%;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f7fa;
    color: #909399;
    border: 1px dashed #dcdfe6;
    border-radius: 4px;
  }
}
</style> 